import React from 'react';
import { SnowflakeIcon, ShoppingCartIcon, UtensilsCrossedIcon } from 'lucide-react';
const pillars = [{
  icon: UtensilsCrossedIcon,
  title: 'Paladar argentino',
  body: 'Milanesas, guisos, tartas, ensaladas y viandas. No es dieta ni comida de hospital.'
}, {
  icon: SnowflakeIcon,
  title: 'El freezer, tu aliado',
  body: 'Qué congelar, cómo y por cuánto tiempo para que todo salga igual de rico.'
}, {
  icon: ShoppingCartIcon,
  title: 'Compra inteligente',
  body: 'Comprás por menú, no por impulso: el ticket del súper baja drásticamente.'
}];
export function Method() {
  return <section className="w-full bg-white" data-id="element-96" data-mp="3pg352dblhxtx">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-24" data-id="element-97" data-mp="3u7l42vu25oc9">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16" data-id="element-98" data-mp="3u95xgi4mz18j">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/c6beb926-e96c-41a7-9870-da7631dc9a94.jpg" alt="Heladera organizada con recipientes rotulados y verduras lavadas en cajones" className="w-full rounded-2xl object-cover shadow-card" data-id="element-99" data-mp="2wr5xp58x9lfy" />
          <div data-id="element-100" data-mp="khcyriojsrwf">
            <p className="font-sans text-sm font-bold uppercase tracking-[0.16em] text-tomato" data-id="element-101" data-mp="kgv3opdmgjq3">
              Presentamos
            </p>
            <h2 className="mt-3 font-display text-4xl font-black leading-[1.1] text-ink sm:text-5xl" data-id="element-102" data-mp="bnzuxloy45vk">
              El Método
              <br data-id="element-103" data-mp="6p6t4qj0u3b8" />
              Cocina en 3 Horas
            </h2>
            <p className="mt-5 font-sans text-lg leading-relaxed text-ink/80" data-id="element-104" data-mp="1ptw5cyfrfux">
              Un sistema diseñado para la familia argentina real. Es el arte del{' '}
              <em className="not-italic font-semibold" data-id="element-105" data-mp="3swn4r1vk6h9h">meal prep</em> adaptado a nuestro
              paladar: todo pre-listo, rotulado y organizado.
            </p>

            <ul className="mt-8 space-y-5" data-id="element-106" data-mp="1r51st1k5fya5">
              {pillars.map(({
              icon: Icon,
              title,
              body
            }) => <li key={title} className="flex gap-4" data-id="element-107" data-mp="1n484w86pijh9">
                  <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-olive/10 text-olive" data-id="element-108" data-mp="3glvwcq4las23">
                    <Icon aria-hidden="true" className="h-5 w-5" data-id="element-109" data-mp="3lcvsht5vx63j" />
                  </span>
                  <div data-id="element-110" data-mp="37lqzvb0xpe2p">
                    <h3 className="font-sans font-bold text-ink" data-id="element-111" data-mp="37mikxrwwnteq">{title}</h3>
                    <p className="font-sans text-[15px] leading-relaxed text-muted" data-id="element-112" data-mp="3bmatw5q7o1km">
                      {body}
                    </p>
                  </div>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}